import styles from "./FilterFlyoutBar.module.scss";

// components
import { RoundedButton } from "components/LibraryComponents/Components";
import {
  LocationFilterButton,
  NaicsFilterButton,
  SbaFilterButton,
  SelfFilterButton,
  KeywordFilterButton,
  LastUpdatedFilterButton,
  BusinessSizeFilterButton,
  AnnualRevenueFilterButton,
  MoreFilterButton,
} from "components/FilterButtons";

// constants
import { Permissions } from "constants/permissions";

// store
import useFiltersStore from "store/useFiltersStoreNew";
import useAuthStore from "store/useAuthStore";

export default function FilterFlyoutBar() {
  const { areFiltersApplied, clearFilters } = useFiltersStore((state) => ({
    areFiltersApplied: state.areFiltersApplied(),
    clearFilters: state.clearFilters,
  }));
  const { user } = useAuthStore();

  const role = user?.role ?? "guest"
  const privileged = Permissions[role]?.privilegedSearch ?? false;

  return (
    <div className={styles["filter-flyout-bar-root"]}>
      <LocationFilterButton />
      <SbaFilterButton />
      <NaicsFilterButton />
      <KeywordFilterButton />
      {/* SBS-S30 Self-certificate will be called us Business type */}
      <SelfFilterButton />
      <LastUpdatedFilterButton />
      {privileged && <BusinessSizeFilterButton />}
      {privileged && <AnnualRevenueFilterButton />}
      <MoreFilterButton />
      <RoundedButton
        variant="ghost"
        disabled={!areFiltersApplied}
        onClick={clearFilters}
      >
        Clear filters
      </RoundedButton>
    </div>
  );
}
